"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4265],{

/***/ 86314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);




/* eslint-disable @next/next/no-img-element */ 


var publicRuntimeConfig = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])().publicRuntimeConfig;
var publicOptions = publicRuntimeConfig.publicOptions;
var path = __webpack_require__(62520);
/** ========== */ /**
 *
 * @param {{
 * image;
 * src;
 * alt;
 * placeholder;
 * priority;
 * wrapper:{className,style};
 * width:String|Number;
 * heightString|Number;
 * }} props Props for the component
 *
 */ var ratioScreen = {
    sm: 375,
    md: 768,
    lg: 1280
};
var ImgUse = function(_param) {
    var image = _param.image, src = _param.src, alt = _param.alt, placeholder = _param.placeholder, priority = _param.priority, wrapper = _param.wrapper, width = _param.width, height = _param.height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "image",
        "src",
        "alt",
        "placeholder",
        "priority",
        "wrapper",
        "width",
        "height"
    ]);
    var srcStatic = src ? src.replace(/^\/+/, "") : placeholder.replace(/^\/+/, "");
    if (image && image.constructor === Object && Object.keys(image).length !== 0) {
        var ref, ref1;
        var webpEnable = publicOptions === null || publicOptions === void 0 ? void 0 : (ref = publicOptions.options) === null || ref === void 0 ? void 0 : (ref1 = ref.acf) === null || ref1 === void 0 ? void 0 : ref1.webpEnable;
        if (webpEnable) {
            var ref2, ref3, ref4, ref5, ref6, ref7;
            var webpSeparateFolder = publicOptions === null || publicOptions === void 0 ? void 0 : (ref2 = publicOptions.options) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.acf) === null || ref3 === void 0 ? void 0 : ref3.webpSeparateFolder;
            var defaultPath = "/wp-content/uploads";
            var separatePath = "/wp-content/webp-express/webp-images/uploads";
            var srcSet = [];
            var originalSize = "".concat(image === null || image === void 0 ? void 0 : image.sourceUrl, ".webp ").concat(image === null || image === void 0 ? void 0 : (ref4 = image.mediaDetails) === null || ref4 === void 0 ? void 0 : ref4.width, "w");
            originalSize = webpSeparateFolder ? originalSize.split(defaultPath).join(separatePath) : originalSize;
            srcSet.push(originalSize);
            var sizes = (image === null || image === void 0 ? void 0 : (ref5 = image.mediaDetails) === null || ref5 === void 0 ? void 0 : ref5.sizes) || [];
            if (sizes.length > 0) {
                sizes.forEach(function(size) {
                    var newSize = "".concat(size === null || size === void 0 ? void 0 : size.sourceUrl, ".webp ").concat(size === null || size === void 0 ? void 0 : size.width, "w");
                    newSize = webpSeparateFolder ? newSize.split(defaultPath).join(separatePath) : newSize;
                    srcSet.push(newSize);
                });
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                type: "image/webp",
                                srcSet: srcSet.join(", "),
                                sizes: image === null || image === void 0 ? void 0 : image.sizes
                            }, props)),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
                                loading: "".concat(priority ? null : "lazy"),
                                decoding: "async",
                                src: image === null || image === void 0 ? void 0 : image.sourceUrl,
                                srcSet: image === null || image === void 0 ? void 0 : image.srcSet,
                                sizes: image === null || image === void 0 ? void 0 : image.sizes,
                                width: image === null || image === void 0 ? void 0 : (ref6 = image.mediaDetails) === null || ref6 === void 0 ? void 0 : ref6.width,
                                height: image === null || image === void 0 ? void 0 : (ref7 = image.mediaDetails) === null || ref7 === void 0 ? void 0 : ref7.height,
                                alt: (image === null || image === void 0 ? void 0 : image.altText) ? image === null || image === void 0 ? void 0 : image.altText : alt
                            }))
                        ]
                    })
                }))
            });
        } else {
            var ref8, ref9;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
                        loading: "".concat(priority ? null : "lazy"),
                        decoding: "async",
                        src: image === null || image === void 0 ? void 0 : image.sourceUrl,
                        srcSet: image === null || image === void 0 ? void 0 : image.srcSet,
                        sizes: image === null || image === void 0 ? void 0 : image.sizes,
                        width: image === null || image === void 0 ? void 0 : (ref8 = image.mediaDetails) === null || ref8 === void 0 ? void 0 : ref8.width,
                        height: image === null || image === void 0 ? void 0 : (ref9 = image.mediaDetails) === null || ref9 === void 0 ? void 0 : ref9.height,
                        alt: (image === null || image === void 0 ? void 0 : image.altText) ? image === null || image === void 0 ? void 0 : image.altText : alt
                    }))
                }))
            });
        }
    } else {
        var extname = path.extname(srcStatic).toLowerCase();
        var isPng = extname.localeCompare(".png") == 0;
        var isJpeg = extname.localeCompare(".jpg") == 0 || extname.localeCompare(".jpeg") == 0;
        if (isPng || isJpeg) {
            var srcSplit = srcStatic.split(".")[0];
            var srcArr = srcSplit.split("/");
            var srcOptimize = "assets/optimize-images/".concat(srcArr[srcArr.length - 1]);
            var ratio_sm = ratioScreen.sm / width;
            var ratio_md = ratioScreen.md / width;
            var ratio_lg = ratioScreen.lg / width;
            var sm = {
                width: ratioScreen.sm,
                height: Math.round(ratio_sm * height)
            };
            var md = {
                width: ratioScreen.md,
                height: Math.round(ratio_md * height)
            };
            var lg = {
                width: ratioScreen.lg,
                height: Math.round(ratio_lg * height)
            };
            if (width <= ratioScreen.sm) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        priority && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "preload",
                                href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(width, "x").concat(height, ".webp"),
                                as: "image",
                                type: "image/webp",
                                media: "(max-width: ".concat(sm.width, "px)")
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(width, "x").concat(height, ".webp"),
                                        media: "(max-width: ".concat(sm.width, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        loading: "".concat(priority ? null : "lazy"),
                                        decoding: "async",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcStatic),
                                        alt: alt,
                                        width: width,
                                        height: height
                                    }, props))
                                ]
                            })
                        }))
                    ]
                });
            } else if (width > ratioScreen.sm && width < ratioScreen.md) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        priority && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(sm.width, "x").concat(sm.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(max-width: ".concat(sm.width, "px)")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(width, "x").concat(height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(min-width: ".concat(sm.width + 1, "px) and (max-width: ").concat(md.width - 1, "px)")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(sm.width, "x").concat(sm.height, ".webp"),
                                        media: "(max-width: ".concat(sm.width, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(width, "x").concat(height, ".webp"),
                                        media: "(min-width: ".concat(sm.width + 1, "px) and (max-width: ").concat(md.width - 1, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        loading: "".concat(priority ? null : "lazy"),
                                        decoding: "async",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcStatic),
                                        alt: alt,
                                        width: width,
                                        height: height
                                    }, props))
                                ]
                            })
                        }))
                    ]
                });
            } else if (width >= 768 && width <= 1279) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        priority && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(sm.width, "x").concat(sm.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(max-width: ".concat(sm.width, "px)")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(md.width, "x").concat(md.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(min-width: ".concat(sm.width + 1, "px) and (max-width: ").concat(md.width - 1, "px)")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(width, "x").concat(height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(min-width: ".concat(md.width, "px) and (max-width: ").concat(ratioScreen.lg - 1, "px)")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(sm.width, "x").concat(sm.height, ".webp"),
                                        media: "(max-width: ".concat(sm.width, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(md.width, "x").concat(md.height, ".webp"),
                                        media: "(min-width: ".concat(sm.width + 1, "px) and (max-width: ").concat(md.width - 1, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(width, "x").concat(height, ".webp"),
                                        media: "(min-width: ".concat(md.width, "px) and (max-width: ").concat(lg.width - 1, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        loading: "".concat(priority ? null : "lazy"),
                                        decoding: "async",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcStatic),
                                        alt: alt,
                                        width: width,
                                        height: height
                                    }, props))
                                ]
                            })
                        }))
                    ]
                });
            } else if (width >= 1280) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        priority && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(sm.width, "x").concat(sm.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(max-width: ".concat(sm.width, "px)")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(md.width, "x").concat(md.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(min-width: ".concat(sm.width + 1, "px) and (max-width: ").concat(md.width - 1, "px)")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(lg.width, "x").concat(lg.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(min-width: ".concat(md.width, "px) and (max-width: ").concat(ratioScreen.lg - 1, "px)")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(lg.width, "x").concat(lg.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "min-width: ".concat(lg.width, "px")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(sm.width, "x").concat(sm.height, ".webp"),
                                        media: "(max-width: ".concat(sm.width, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(md.width, "x").concat(md.height, ".webp"),
                                        media: "(min-width: ".concat(sm.width + 1, "px) and (max-width: ").concat(md.width - 1, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(lg.width, "x").concat(lg.height, ".webp"),
                                        media: "(min-width: ".concat(md.width, "px) and (max-width: ").concat(lg.width - 1, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(lg.width, "x").concat(lg.height, ".webp"),
                                        media: "min-width: ".concat(lg.width, "px")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        loading: "".concat(priority ? null : "lazy"),
                                        decoding: "async",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcStatic),
                                        alt: alt,
                                        width: width,
                                        height: height
                                    }, props))
                                ]
                            })
                        }))
                    ]
                });
            }
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    priority && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "preload",
                            as: "image",
                            href: "".concat(publicOptions.basePath, "/").concat(srcStatic)
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            loading: "".concat(priority ? null : "lazy"),
                            decoding: "async",
                            src: "".concat(publicOptions.basePath, "/").concat(srcStatic),
                            alt: alt,
                            width: width,
                            height: height
                        }, props))
                    }))
                ]
            });
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            priority && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: "".concat(publicOptions.basePath, "/").concat(srcStatic)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
                    loading: "".concat(priority ? null : "lazy"),
                    decoding: "async",
                    src: "".concat(publicOptions.basePath, "/").concat(srcStatic),
                    alt: alt
                }))
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImgUse);
ImgUse.propTypes = {
    image: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
    src: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    priority: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    wrapper: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object)
};
ImgUse.defaultProps = {
    image: {},
    src: null,
    alt: "placeholder",
    placeholder: "assets/common/placeholder.jpg",
    priority: false,
    wrapper: {
        className: "inline-block"
    }
}; /** ========== */ 


/***/ })

}]);